import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l0 -15","key":"svg-0"}],["path",{"d":"M15 6l-3 -3l-3 3","key":"svg-1"}],["path",{"d":"M15 21l-3 -3l-3 3","key":"svg-2"}]]

/**
 * IconArrowUpTail
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtdGFpbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMThsMCAtMTUiIC8+CiAgPHBhdGggZD0iTTE1IDZsLTMgLTNsLTMgMyIgLz4KICA8cGF0aCBkPSJNMTUgMjFsLTMgLTNsLTMgMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-up-tail
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpTail = createReactComponent('outline', 'arrow-up-tail', 'ArrowUpTail', __iconNode);

export default IconArrowUpTail;